export default {
    props: {
      loading: {
        type: Boolean,
        required: true
      },
      label: {
        type: String,
        default: "Loading..."
      },
      overlay: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return ({
        loader_src: require("@/assets/images/home_icons/EngageNet-Connected-Loader-4K-Transparent.webm"),
        loader_video_ready: false
      });
    },
    methods: {
      mark_loader_video_ready() {
        this.loader_video_ready = true;
      },
      mark_loader_video_failed() {
        this.loader_video_ready = false;
      }
    }
  }
